import { animalsActions as animals } from 'src/store/animals/animals.actions';

const initialState = {
  animals: {
    isFetching: false,
    animals: null,
    error: false,
    errorcodes: [],
  },
  animalKeeping: {
    isFetching: false,
    animalKeeping: null,
    error: false,
    errorcodes: [],
  },
};

const animalsReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'RESET_STORE':
    return initialState;
  case animals.fetch().type:
    return {
      ...state,
      animals: {
        ...state.animals,
        isFetching: true,
        error: false,
      },
    };
  case animals.fetchSuccess().type: {
    return {
      ...state,
      animals: {
        ...state.animals,
        animals: action?.payload?.animals || null,
        isFetching: false,
        error: false,
      },
    }; }
  case animals.fetchFailure().type:
    return {
      ...state,
      animals: {
        ...state.animals,
        animals: null,
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };
  case animals.fetchAnimalKeeping().type:
    return {
      ...state,
      animalKeeping: {
        ...state.animalKeeping,
        isFetching: true,
        error: false,
      },
    };
  case animals.fetchAnimalKeepingSuccess().type:
    return {
      ...state,
      animalKeeping: {
        ...state.animalKeeping,
        animalKeeping: action.payload.animalKeeping,
        isFetching: false,
        error: false,
      },
    };
  case animals.fetchAnimalKeepingFailure().type:
    return {
      ...state,
      animalKeeping: {
        ...state.animalKeeping,
        animalKeeping: null,
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };
  default:
    return state;
  }
};

export default animalsReducer;
